import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {
  CHECKAUTH_QUERY,
  DOCUMENT_STATIC_DATA,
  INTERMEDIARY_LIST,
  VIEW_QUOTE_FIRE_SA,
  VIEW_QUOTE_FIRE,
  META_QUERIES
} from './queries';
// import Loading from '../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
// import {
//   updateFireQuote,
//   updateFireQuoteUploadDocsVar,
// } from '../capture-details/fire/_graphql/state';
import { updateFireQuote, updateFireQuoteUploadDocsVar, } from 'quanta-flows/modules/quote/fire/state';
import { Card, useResponsiveParams, Text } from 'quanta-ui';
// import { ClientService, Layout } from '../../../lib/layout';
import { ClientService, Layout } from 'quanta-flows/modules/layout';
// import CaptureFireDetails from '../capture-details/fire';
import CaptureFireDetailsSF from '../capture-details/fire/Standalone Fire';

import { useFetchQuery } from 'quanta-flows';
export default function ViewQuoteDetailsFire() {
  const fetchQuery = useFetchQuery();
  const { quote_number } = useParams();

  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const {
    loading: loadingRole,
    error: errorRole,
    data: dataRole,
  } = useQuery(CHECKAUTH_QUERY, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);
  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });
  const { loading:load1, error:error1, data:viewfire } = useQuery(VIEW_QUOTE_FIRE, {
    variables: {
      input: {
        quoteNumber: quote_number,
      },
    },
  })
  const { loading, error, data } = useQuery(VIEW_QUOTE_FIRE_SA, {
    variables: {
      input: {
        quoteNumber: quote_number,
      },
    },
    onCompleted: async (data) => {
      try {
        const metaQuery = fetchQuery({
          query: META_QUERIES,
          variables: {
            productCode: data?.viewQuoteFireSA?.product?.productCode,
            productType: data?.viewQuoteFireSA?.productType,
          },
        });
        //setLoadingMetaQueries(true);
        const { data: metaQueryData } = await metaQuery;
        const {
          lobProductList,
          // getPCVBusinessType,
          // PRD_TotalClaimCountList,
          // PRD_PreviousPolicyTermList,
        } = metaQueryData;
        updateFireQuote({
          quoteNumber: data?.viewQuoteFireSA?.quoteNumber
            ? `${data?.viewQuoteFireSA?.quoteNumber}`
            : '',
          currentTab:
            data?.viewQuoteFireSA?.status?.toString()?.toLowerCase() ===
              'pending uw approval' &&
            dataRole.checkAuth.role.roleName
              ?.toString()
              ?.toLowerCase() === 'underwriter'
              ? 2
              : data?.viewQuoteFireSA?.stageIndex,
          proposalNumber: data?.viewQuoteFireSA?.proposalNumber
            ? `${data?.viewQuoteFireSA?.proposalNumber}`
            : '',
          quoteCreationDate: data?.viewQuoteFireSA?.quoteCreationDate
            ? `${data?.viewQuoteFireSA?.quoteCreationDate}`
            : '',
          status: data?.viewQuoteFireSA?.status
            ? `${data?.viewQuoteFireSA?.status}`
            : '',
          productCode: data?.viewQuoteFireSA?.product?.productCode, //viewQuoteFireSA.product.productCode
          productTypeValue: lobProductList
            ?.find(
              (lpl) =>
                lpl?.lob_code?.toString()?.toLowerCase() ===
                data?.viewQuoteFireSA?.lob?.lobCode
                  ?.toString()
                  ?.toLowerCase(),
            )
            ?.products?.find(
              (prd) =>
                prd?.product_code?.toString()?.toLowerCase() ===
                data?.viewQuoteFireSA?.product?.productCode
                  ?.toString()
                  ?.toLowerCase(),
            )
            ?.product_types?.find(
              (p) =>
                p?.code?.toLowerCase() ===
                data?.viewQuoteFireSA?.productType?.toLowerCase(),
            )?.value,
          intermediaryDetails: {
            code: data?.viewQuoteFireSA?.intermediaryDetails?.code
              ? `${data?.viewQuoteFireSA?.intermediaryDetails?.code}`
              : '',
            name: data?.viewQuoteFireSA?.intermediaryDetails?.name
              ? `${data?.viewQuoteFireSA?.intermediaryDetails?.name}`
              : '',
            location: data?.viewQuoteFireSA?.intermediaryDetails
              ?.location
              ? `${data?.viewQuoteFireSA?.intermediaryDetails?.location}`
              : '',
            fieldUserCode: data?.viewQuoteFireSA?.intermediaryDetails
              ?.fieldUserCode
              ? `${data?.viewQuoteFireSA?.intermediaryDetails?.fieldUserCode}`
              : '',
            fieldUserName: data?.viewQuoteFireSA?.intermediaryDetails
              ?.fieldUserName
              ? `${data?.viewQuoteFireSA?.intermediaryDetails?.fieldUserName}`
              : '',
          },
          productKg: data?.viewQuoteFireSA?.productKg,
          basisOfValuation: data?.viewQuoteFireSA?.basisOfValuation,
          otherDetails:{
            premisesRentedOut:data?.viewQuoteFireSA?.otherDetails?.premisesRentedOut,
            ownerOccupant: data?.viewQuoteFireSA?.otherDetails?.ownerOccupant,
          },
          loadingAndDiscount: {
            discountPercentage: data?.viewQuoteFireSA?.loadingAndDiscount?.discountPercentage,
            loadingPercentage: data?.viewQuoteFireSA?.loadingAndDiscount?.loadingPercentage,
          },
          eqZone: data?.viewQuoteFireSA?.eqZone
          ?`${data?.viewQuoteFireSA?.eqZone}`
          :'',
          locationCode: data?.viewQuoteFireSA?.locationCode
          ?`${data?.viewQuoteFireSA?.locationCode}`
          :'',
          pinCodeLocality: data?.viewQuoteFireSA?.pinCodeLocality
          ?`${data?.viewQuoteFireSA?.pinCodeLocality}`
          :'',
          city: data?.viewQuoteFireSA?.city
          ?`${data?.viewQuoteFireSA?.city}`
          :'',
          district: data?.viewQuoteFireSA?.district
          ?`${data?.viewQuoteFireSA?.district}`
          :'',
          state: data?.viewQuoteFireSA?.state
          ?`${data?.viewQuoteFireSA?.state}`
          :'',
          pincode: data?.viewQuoteFireSA?.pincode
          ?`${data?.viewQuoteFireSA?.pincode}`
          :'',
          pendingMessage:data?.viewQuoteFireSA?.underwriterMsg,
          customerDetails:
          {
            customerType:{
            code : data?.viewQuoteFireSA?.customerDetails?.customerType?.code,
            value : data?.viewQuoteFireSA?.customerDetails?.customerType?.value
            },
            orgInsuredName :data?.viewQuoteFireSA?.customerDetails?.orgInsuredName,
            firstName : data?.viewQuoteFireSA?.customerDetails?.firstName,
            middleName : data?.viewQuoteFireSA?.customerDetails?.middleName,
            lastName: data?.viewQuoteFireSA?.customerDetails?.lastName,
          },
          finalisedPremium: {
            locationNetPremium: data?.viewQuoteFireSA?.finalisedPremium
              ?.locNetPremium
              ? `${data?.viewQuoteFireSA?.finalisedPremium?.locNetPremium}`
              : '',
            locationGST: data?.viewQuoteFireSA?.finalisedPremium?.locGST
              ? `${data?.viewQuoteFireSA?.finalisedPremium?.locGST}`
              : '',
            locationTotalPremium: data?.viewQuoteFireSA
              ?.finalisedPremium?.locTotalPremium
              ? `${data?.viewQuoteFireSA?.finalisedPremium?.locTotalPremium}`
              : '',
            stampDuty: data?.viewQuoteFireSA?.finalisedPremium
              ?.stampDuty
              ? `${data?.viewQuoteFireSA?.finalisedPremium?.stampDuty}`
              : '',
            basicRate: data?.viewQuoteFireSA?.finalisedPremium?.basicRate
              ? `${data?.viewQuoteFireSA?.finalisedPremium?.basicRate}`
              : data?.viewQuoteFireSA?.riskLocations[0]?.premium?.basicRate
              ? `${data?.viewQuoteFireSA?.riskLocations[0]?.premium?.basicRate.toString()}`
              : '',
          },
          coverData: {
            addOnCovers: data?.viewQuoteFireSA?.riskCovers,
            rawRiskData: [],
          },
          riskcoverdata:data?.viewQuoteFireSA?.riskCovers,
          tabDetails: {
            customerTabDetails: {
              previousClaimExperienceDetails: {
                isClaimMadeInPreviousYears:
                  data?.viewQuoteFireSA?.prevClaimExpDtls
                    ?.anyPrevClaimsExp === true
                    ? 'Yes'
                    : 'No',
                claimInPreviousYearsInfo: data?.viewQuoteFireSA
                  ?.prevClaimExpDtls?.prevClaimExpDesc
                  ? `${data?.viewQuoteFireSA?.prevClaimExpDtls?.prevClaimExpDesc}`
                  : '',
              },
              customerDetails: {
                customer: {
                  id: data?.viewQuoteFireSA?.customer?.cust_number,
                  customerType:
                    data?.viewQuoteFireSA?.customer?.cust_type?.code,
                  orgName: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.org_name,
                    '',
                  ),
                  orgType: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.org_type?.code,
                    '',
                  ),
                  contactName: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.contact_name,
                    '',
                  ),
                  title: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail?.title
                    ?.code,
                    '',
                  ),
                  gender: reformData(
                    data?.viewQuoteFireSA?.customer?.gender?.code,
                    '',
                  ),
                  proposerDOB: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.date_of_birth,
                    '',
                  ),
                firstName: reformData(
                  data?.viewQuoteFireSA?.customer?.indv_detail
                    ?.first_name,
                  '',
                ),
                middleName: reformData(
                  data?.viewQuoteFireSA?.customer?.indv_detail
                    ?.middle_name,
                  '',
                ),
                fullName: reformData(
                  data?.viewQuoteFireSA?.customer?.indv_detail
                    ?.full_name,
                  '',
                ),
                lastName: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.surname,
                  '',
                ),
                  nationality: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.nationality?.code,
                    '',
                  ),
                  occupation: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.occupation?.code,
                    '',
                  ),
                  maritalStatus: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.marital_status?.code,
                    '',
                  ),
                  panNumber: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.pan_card_number,
                    '',
                  ),
                  idProofType: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.id_proof_type?.code,
                    '',
                  ),
                  idProofNumber: reformData(
                    data?.viewQuoteFireSA?.customer?.indv_detail
                      ?.id_proof_number,
                    '',
                  ),
                  permAddressLine1: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.address_line1,
                    '',
                  ),
                  permAddressLine2: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.address_line2,
                    '',
                  ),
                  permAddressLine3: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.address_line3,
                    '',
                  ),
                  permLandmark: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.land_mark,
                    '',
                  ),
                  permPincode: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.pin_code,
                    '',
                  ),
                  permCityTownVillage: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.city,
                    '',
                  ),
                  permDistrict: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.district,
                    '',
                  ),
                  permState: reformData(
                    data?.viewQuoteFireSA?.customer?.permanent_address
                      ?.state,
                    '',
                  ),
                  permCommAddressYN: data?.viewQuoteFireSA?.customer
                    ?.comm_equal_perm
                    ? true
                    : false,
                  commAddressLine1: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.address_line1,
                    '',
                  ),
                  commAddressLine2: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.address_line2,
                    '',
                  ),
                  commAddressLine3: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.address_line3,
                    '',
                  ),
                  commLandmark: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.land_mark,
                    '',
                  ),
                  commPincode: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.pin_code,
                    '',
                  ),
                  commCityTownVillage: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.city,
                    '',
                  ),
                  commDistrict: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.district,
                    '',
                  ),
                  commState: reformData(
                    data?.viewQuoteFireSA?.customer
                      ?.communication_address?.state,
                    '',
                  ),
                  emailID: reformData(
                    data?.viewQuoteFireSA?.customer?.contact?.email,
                    '',
                  ),
                  mobileNo: reformData(
                    data?.viewQuoteFireSA?.customer?.contact?.mobile,
                    '',
                  ),
                  phoneNo: reformData(
                    data?.viewQuoteFireSA?.customer?.contact?.telephone,
                    '',
                  ),
                  faxNo: reformData(
                    data?.viewQuoteFireSA?.customer?.contact
                      ?.fax_number,
                    '',
                  ),
                  altPhoneNo: reformData(
                    data?.viewQuoteFireSA?.customer?.contact
                      ?.alt_telephone,
                    '',
                  ),
                  altMobileNo: reformData(
                    data?.viewQuoteFireSA?.customer?.contact
                      ?.alt_mobile,
                    '',
                  ),
                  regNumber: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.reg_number,
                    '',
                  ),
                  tanNumber: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.tan_number,
                    '',
                  ),
                  gstNumber: reformData(
                    data?.viewQuoteFireSA?.customer?.org_detail
                      ?.gst_number ||
                      data?.viewQuoteFireSA?.customer?.indv_detail
                        ?.gst_number,
                    '',
                  ),
                },
                customerMeta: {
                  crn: reformData(
                    data?.viewQuoteFireSA?.customer?.cust_ref_number,
                    '',
                  ),
                  isNewCustomer: data?.viewQuoteFireSA?.customer
                    ?.cust_number
                    ? false
                    : true,
                  ifscCode: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail
                      ?.ifsc_code,
                    '',
                  ),
                  bankName: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail?.name,
                    '',
                  ),
                  branchName: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail
                      ?.branch_name,
                    '',
                  ),
                  bankAcno: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail
                      ?.acc_number,
                    '',
                  ),
                  accountHolderName: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail
                      ?.acc_holder,
                    '',
                  ),
                  micrCode: reformData(
                    data?.viewQuoteFireSA?.customer?.bank_detail
                      ?.micr_code,
                    '',
                  ),
                },
                // customerType: {
                //   code: data?.viewQuoteFireSA?.customer?.cust_type
                //     ?.code,
                //   value:
                //     data?.viewQuoteFireSA?.customer?.cust_type?.value,
                // },
                // firstName: reformData(
                //   data?.viewQuoteFireSA?.customer?.indv_detail
                //     ?.first_name,
                //   '',
                // ),
                // middleName: reformData(
                //   data?.viewQuoteFireSA?.customer?.indv_detail
                //     ?.middle_name,
                //   '',
                // ),
                // fullName: reformData(
                //   data?.viewQuoteFireSA?.customer?.indv_detail
                //     ?.full_name,
                //   '',
                // ),
                // lastName: reformData(
                //   data?.viewQuoteFireSA?.customer?.indv_detail?.surname,
                //   '',
                // ),
                businessOfInsured: data?.viewQuoteFireSA
                  ?.businessOfInsured
                  ? `${data?.viewQuoteFireSA?.businessOfInsured}`
                  : '',
                // orgInsuredName: reformData(
                //   data?.viewQuoteFireSA?.customer?.org_detail?.org_name,
                //   '',
                //),
              },
              
              policyTypeDetails: {
                isInsuranceForKutchaConstruction:
                  data?.viewQuoteFireSA?.isKutchaConstruct === true
                    ? 'Yes'
                    : 'No',
                    geographicalArea:data?.viewQuoteFireSA?.district
                    ?`${data?.viewQuoteFireSA?.district}`
                    :'',
                policyOrCoverType: {
                  code: data?.viewQuoteFireSA?.policyType
                    ? `${data?.viewQuoteFireSA?.policyType}`
                    : '',
                  value: data?.viewQuoteFireSA?.policyType
                    ? `${data?.viewQuoteFireSA?.policyType}`
                    : '',
                },
                tenure: {
                  code: data?.viewQuoteFireSA?.tenure?.code,
                  value: data?.viewQuoteFireSA?.tenure?.value,
                },
                policyStartDate: data?.viewQuoteFireSA?.policyStartDate
                  ? `${data?.viewQuoteFireSA?.policyStartDate}`
                  : '',
                policyExpiryDate: data?.viewQuoteFireSA
                  ?.policyExpiryDate
                  ? `${data?.viewQuoteFireSA?.policyExpiryDate}`
                  : '',
              },
            },
            riskLocationTabDetails: {
              nonFloaterType:
                data?.viewQuoteFireSA?.policyType
                  ?.toString().includes('Home') 
                  //=== 'Home Building And Home Contents'
                  ? {
                      occupancy: {
                        code: data?.viewQuoteFireSA?.riskLocations[0]
                          ?.occupancyCodeValue?.code
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.code}`
                          : '',
                        value: data?.viewQuoteFireSA?.riskLocations[0]
                          ?.occupancyCodeValue?.value
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.value}`
                          : '',
                        occupancySection: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.occupancySection
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.occupancySection}`
                          : '',
                        occupancyRate: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.occupancyRate
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.occupancyRate}`
                          : '',
                        riskCode: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.riskCode
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.riskCode}`
                          : '',
                        rateCode: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.rateCode
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.rateCode}`
                          : '',
                        riskGrade: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.riskGrade
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.riskGrade}`
                          : '',
                        riskGradeDefinition: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.riskGradeDefinition
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.riskGradeDefinition}`
                          : '',
                        riskPreference: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.riskPreference
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.riskPreference}`
                          : '',
                        gicClass: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.gicClass
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.gicClass}`
                          : '',
                        stfiRate: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.stfiRate
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.stfiRate}`
                          : '',
                        rsmdRate: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.occupancyCodeValue
                          ?.rsmdRate
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.occupancyCodeValue?.rsmdRate}`
                          : '',
                      },
                      riskSumInsured: {
                        costOfConstruction: data?.viewQuoteFireSA?.riskLocations[0]?.costOfConstruction
                                          ? data?.viewQuoteFireSA?.riskLocations[0]?.costOfConstruction
                                          :'',
                        carpetArea: data?.viewQuoteFireSA?.riskLocations[0]?.carpetArea
                                          ? data?.viewQuoteFireSA?.riskLocations[0]?.carpetArea
                                          :'',
                        buildingValue: data?.viewQuoteFireSA?.riskLocations[0]?.buildingValue
                                          ? data?.viewQuoteFireSA?.riskLocations[0]?.buildingValue
                                          :'',
                        additionalStructure: data?.viewQuoteFireSA?.riskLocations[0]?.additionalStructure
                                          ? data?.viewQuoteFireSA?.riskLocations[0]?.additionalStructure
                                          :'',
                        totalBuildingSI: data?.viewQuoteFireSA?.riskLocations[0]?.totalBuildingSI
                                          ? data?.viewQuoteFireSA?.riskLocations[0]?.totalBuildingSI
                                          :'',
                      },
                      stock: {
                        generalContentSI: data?.viewQuoteFireSA?.riskLocations[0]?.generalContentSI
                        ? data?.viewQuoteFireSA?.riskLocations[0]?.generalContentSI
                        :'',
                        additionalContent: data?.viewQuoteFireSA?.riskLocations[0]?.additionalContentSI
                        ? 'Yes'
                        : 'No',
                        additionalContentSI: data?.viewQuoteFireSA?.riskLocations[0]?.additionalContentSI
                        ? data?.viewQuoteFireSA?.riskLocations[0]?.additionalContentSI
                        :'',
                        valuableContent: data?.viewQuoteFireSA?.riskLocations[0]?.valuableContentSI
                        ? 'Yes'
                        : 'No',
                        valuableContentSI: data?.viewQuoteFireSA?.riskLocations[0]?.valuableContentSI
                        ? data?.viewQuoteFireSA?.riskLocations[0]?.valuableContentSI
                        :'',
                        totalContentSI: data?.viewQuoteFireSA?.riskLocations[0]?.totalContentSI
                        ? data?.viewQuoteFireSA?.riskLocations[0]?.totalContentSI
                        :'',
                        totalSumInsured: data?.viewQuoteFireSA?.riskLocations[0]?.totalSumInsured
                        ? data?.viewQuoteFireSA?.riskLocations[0]?.totalSumInsured
                        :'',
                      },
                    ratePerMille: data?.viewQuoteFireSA?.riskLocations[0]?.ratePerMille,
                      riskCovers: [],
                      addressDetails: {
                        addressLine1: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.riskLocAddress
                          ?.address_line1
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.riskLocAddress?.address_line1}`
                          : '',
                        pincode: data?.viewQuoteFireSA?.pincode
                        ?`${data?.viewQuoteFireSA?.pincode}`
                          : '',
                        state: data?.viewQuoteFireSA?.state
                        ?`${data?.viewQuoteFireSA?.state}`
                          : '',
                        eqZone: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.riskLocAddress
                          ?.eqZone
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.riskLocAddress?.eqZone}`
                          : '',
                        district: data?.viewQuoteFireSA?.district
                        ?`${data?.viewQuoteFireSA?.district}`
                          : '',
                        isSamePremise: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.riskLocAddress
                          ?.isSamePremises
                          ? true
                          : false,
                        locationCode: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.riskLocAddress
                          ?.locationCode
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.riskLocAddress?.locationCode}`
                          : '',
                        locationDesc: '',
                      },
                      riskLocationID:
                        data?.viewQuoteFireSA?.riskLocations[0]
                          ?.riskLocationID,
                      floaterLocations:
                        data?.viewQuoteFireSA?.riskLocations[0]
                          ?.floaterLocations?.length > 0
                          ? data?.viewQuoteFireSA?.riskLocations[0]?.floaterLocations?.map(
                              (floaterLocation) => {
                                return {
                                  pinCode: floaterLocation?.pin_code,
                                  state: floaterLocation?.state,
                                  city: floaterLocation?.city,
                                  district: floaterLocation?.district,
                                  eqZone: floaterLocation?.eqZone,
                                  addressLine1:
                                    floaterLocation?.address_line1,
                                  locationCode:
                                    floaterLocation?.locationCode,
                                  showEdit: true,
                                  // addressLine2: floaterLocation?.addressLine2,
                                  // addressLine3: floaterLocation?.addressLine3,
                                  // landmark: floaterLocation?.landmark,
                                };
                              },
                            )
                          : [],
                      // riskSumInsured: {
                      //   stocksSI:
                      //     data?.viewQuoteFireSA?.riskLocations[0]
                      //       ?.stockSI,
                      //   stocksInProcessSI:
                      //     data?.viewQuoteFireSA?.riskLocations[0]
                      //       ?.stocksInProcessSI,
                      //   stocksOnFloaterBasis: 'Yes',
                      //   maximumStockSIAtOneLocation:
                      //     data?.viewQuoteFireSA?.riskLocations[0]
                      //       ?.maxStockSIAtOneLoc,
                      // },
                      fireExtinguisherAppliancesDetails:
                        data?.viewQuoteFireSA?.riskLocations[0]?.fireExtinguishApplisDtls?.map(
                          (fireExtinguisherDtl) => {
                            return {
                              label:
                                fireExtinguisherDtl?.applianceValue
                                  ? fireExtinguisherDtl?.applianceValue
                                  : '',
                              value:
                                fireExtinguisherDtl?.applianceCode
                                  ? fireExtinguisherDtl?.applianceCode
                                  : '',
                              selected:
                                fireExtinguisherDtl?.isSelected
                                  ? true
                                  : false,
                            };
                          },
                        ),
                      otherDetails: {
                        classOfConstruction: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.constructionClass
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.constructionClass}`
                          : '',
                        distanceFromWaterbody: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.waterbodyDistance
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.waterbodyDistance}`
                          : '',
                        securityProvisions: data?.viewQuoteFireSA
                          ?.riskLocations[0]?.securityProvisions
                          ? `${data?.viewQuoteFireSA?.riskLocations[0]?.securityProvisions}`
                          : '',
                      premisesRentedOut: data?.viewQuoteFireSA?.otherDetails?.premisesRentedOut,
                      ownerOccupant: data?.viewQuoteFireSA?.otherDetails?.ownerOccupant,
                      },
                      loadingAndDiscount: {
                        discountPercentage:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.discountPct,
                        loadingPercentage:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.loadingPct,
                      },
                      previousClaimDetails: {
                        claimExperience:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.prevClaimExpDesc,
                      },
                      locationPremium: {
                        locationNetPremium:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.premium?.locationNetPremium,
                        locationGST:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.premium?.locationGST,
                        locationTotalPremium:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.premium?.locationTotalPremium,
                        stampDuty:
                          data?.viewQuoteFireSA?.riskLocations[0]
                            ?.premium?.stampDuty,
                        basicRate: data?.viewQuoteFireSA?.riskLocations[0]?.premium?.basicRate
                        ? `${data?.viewQuoteFireSA?.riskLocations[0]?.premium?.basicRate}`
                        : '',
                      },
                    }
                  : {
                      occupancy: {
                        code: '',
                        value: '',
                        occupancySection: '',
                        occupancyRate: '',
                        riskCode: '',
                        rateCode: '',
                        riskGrade: '',
                        riskGradeDefinition: '',
                        riskPreference: '',
                        gicClass: '',
                        stfiRate: '',
                        rsmdRate: '',
                      },
                      riskLocationID: '',
                      floaterLocations: [],
                      riskSumInsured: {
                        stocksSI: '',
                        stocksInProcessSI: '',
                        stocksOnFloaterBasis: '',
                        maximumStockSIAtOneLocation: '',
                      },
                      fireExtinguisherAppliancesDetails: [],
                      otherDetails: {
                        classOfConstruction: '',
                        distanceFromWaterbody: '',
                        securityProvisions: '',
                      premisesRentedOut: '',
                      ownerOccupant: '',
                      },
                      loadingAndDiscount: {
                        discountPercentage: '',
                        loadingPercentage: '',
                      },
                      previousClaimDetails: {
                        claimExperience: '',
                      },
                      locationPremium: {
                        locationNetPremium: '',
                        locationGST: '',
                        locationTotalPremium: '',
                        stampDuty: '',
                      },
                    },
              FloaterType:
                data?.viewQuoteFireSA?.policyType
                  ?.toString() === 'floater'
                  ? data?.viewQuoteFireSA?.riskLocations?.map(
                      (_, idx) => {
                        return {
                          riskLocationID:
                            data?.viewQuoteFireSA?.riskLocations[idx]
                              ?.riskLocationID,
                          isDeleted: false,
                          occupancy: {
                            code: data?.viewQuoteFireSA?.riskLocations[
                              idx
                            ]?.occupancyCodeValue?.code
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.code}`
                              : '',
                            value: data?.viewQuoteFireSA?.riskLocations[
                              idx
                            ]?.occupancyCodeValue?.value
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.value}`
                              : '',
                            occupancySection: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.occupancySection
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.occupancySection}`
                              : '',
                            occupancyRate: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.occupancyRate
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.occupancyRate}`
                              : '',
                            riskCode: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.riskCode
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.riskCode}`
                              : '',
                            rateCode: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.rateCode
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.rateCode}`
                              : '',
                            riskGrade: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.riskGrade
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.riskGrade}`
                              : '',
                            riskGradeDefinition: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.riskGradeDefinition
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.riskGradeDefinition}`
                              : '',
                            riskPreference: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.riskPreference
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.riskPreference}`
                              : '',
                            gicClass: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.gicClass
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.gicClass}`
                              : '',
                            stfiRate: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.stfiRate
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.stfiRate}`
                              : '',
                            rsmdRate: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.occupancyCodeValue
                              ?.rsmdRate
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.occupancyCodeValue?.rsmdRate}`
                              : '',
                          },
                          isLocationSaved: true,
                          riskSumInsured: {
                            buildingSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.buildingSI,
                            plantMachinerySI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.plantMachinerySI,
                            furnitureFixtureSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.furnitureFixtureSI,
                            rawMaterialSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.rawMaterialSI,
                            otherContentsSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.otherContentsSI,
                          },
                          stock: {
                            stocksSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.stockSI,
                            stocksInProcessSI:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.stocksInProcessSI,
                            stocksOnFloaterBasis:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.stockOnFloaterBasis === true
                                ? 'Yes'
                                : 'No',
                            maximumStockSIAtOneLocation:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.maxStockSIAtOneLoc,
                          },
                          locationSumInsured:
                            data?.viewQuoteFireSA?.riskLocations[idx]
                              ?.locationSI,
                          fireExtinguisherAppliancesDetails:
                            data?.viewQuoteFireSA?.riskLocations[
                              idx
                            ]?.fireExtinguishApplisDtls?.map(
                              (fireExtinguisherDtl) => {
                                return {
                                  label:
                                    fireExtinguisherDtl?.applianceValue
                                      ? fireExtinguisherDtl?.applianceValue
                                      : '',
                                  value:
                                    fireExtinguisherDtl?.applianceCode
                                      ? fireExtinguisherDtl?.applianceCode
                                      : '',
                                  selected:
                                    fireExtinguisherDtl?.isSelected
                                      ? true
                                      : false,
                                };
                              },
                            ),
                          otherDetails: {
                            classOfConstruction: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.constructionClass
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.constructionClass}`
                              : '',
                            distanceFromWaterbody: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.waterbodyDistance
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.waterbodyDistance}`
                              : '',
                            securityProvisions: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.securityProvisions
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.securityProvisions}`
                              : '',
                          premisesRentedOut: data?.viewQuoteFireSA?.otherDetails?.premisesRentedOut,
                          ownerOccupant: data?.viewQuoteFireSA?.otherDetails?.ownerOccupant,
                          },
                          loadingAndDiscount: {
                            discountPercentage:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.discountPct,
                            loadingPercentage:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.loadingPct,
                          },
                          locationPremium: {
                            locationNetPremium:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.premium?.locationNetPremium,
                            locationGST:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.premium?.locationGST,
                            locationTotalPremium:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.premium?.locationTotalPremium,
                            stampDuty:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.premium?.stampDuty,
                          },
                          previousClaimDetails: {
                            claimExperience:
                              data?.viewQuoteFireSA?.riskLocations[idx]
                                ?.prevClaimExpDesc,
                          },
                          addressDetails: {
                            addressLine1: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.address_line1
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.riskLocAddress?.address_line1}`
                              : '',
                            pincode: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.pin_code
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.riskLocAddress?.pin_code}`
                              : '',
                            state: data?.viewQuoteFireSA?.riskLocations[
                              idx
                            ]?.riskLocAddress?.state
                              ? data?.viewQuoteFireSA?.riskLocations[
                                  idx
                                ]?.riskLocAddress?.state
                              : '',
                            eqZone: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.eqZone
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.riskLocAddress?.eqZone}`
                              : '',
                            district: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.district
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.riskLocAddress?.district}`
                              : '',
                            isSamePremise: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.isSamePremises
                              ? true
                              : false,
                            locationCode: data?.viewQuoteFireSA
                              ?.riskLocations[idx]?.riskLocAddress
                              ?.locationCode
                              ? `${data?.viewQuoteFireSA?.riskLocations[idx]?.riskLocAddress?.locationCode}`
                              : '',
                            locationDesc: '',
                          },
                          stockLocations:
                            data?.viewQuoteFireSA?.riskLocations[idx]
                              ?.stockOnFloaterBasis === true
                              ? data?.viewQuoteFireSA?.riskLocations[
                                  idx
                                ]?.floaterLocations?.length > 0
                                ? data?.viewQuoteFireSA?.riskLocations[
                                    idx
                                  ]?.floaterLocations?.map(
                                    (floaterLocation) => {
                                      return {
                                        isDeleted: false,
                                        pincode:
                                          floaterLocation?.pin_code,
                                        state: floaterLocation?.state,
                                        city: floaterLocation?.city,
                                        district:
                                          floaterLocation?.district,
                                        eqZone:
                                          floaterLocation?.eqZone,
                                        addressLine1:
                                          floaterLocation?.address_line1,
                                        locationCode:
                                          floaterLocation?.locationCode,
                                      };
                                    },
                                  )
                                : []
                              : [],
                        };
                      },
                    )
                  : [],
            },
            additionalTabDetails: {
              clauses: {
                defaultClauses:
                  data?.viewQuoteFireSA?.clauses?.default &&
                  data?.viewQuoteFireSA?.clauses?.default?.length > 0
                    ? data?.viewQuoteFireSA?.clauses?.default
                    : [],
                userDefinedClauses:
                  data?.viewQuoteFireSA?.clauses?.userDefined &&
                  data?.viewQuoteFireSA?.clauses?.userDefined?.length >
                    0
                    ? data?.viewQuoteFireSA?.clauses?.userDefined
                    : [],
                Description:
                data?.viewQuoteFireSA?.clauses?.Description &&
                data?.viewQuoteFireSA?.clauses?.Description?.length >
                  0
                  ? data?.viewQuoteFireSA?.clauses?.Description
                  : [],
                ClauseCode:
                data?.viewQuoteFireSA?.clauses?.ClauseCode &&
                data?.viewQuoteFireSA?.clauses?.ClauseCode?.length >
                  0
                  ? data?.viewQuoteFireSA?.clauses?.ClauseCode
                  : [],
                ClauseNumber:
                data?.viewQuoteFireSA?.clauses?.ClauseNumber &&
                data?.viewQuoteFireSA?.clauses?.ClauseNumber?.length >
                  0
                  ? data?.viewQuoteFireSA?.clauses?.ClauseNumber
                  : [],
              },
              conditions: {
                defaultConditions:
                  data?.viewQuoteFireSA?.conditions?.default &&
                  data?.viewQuoteFireSA?.conditions?.default?.length > 0
                    ? data?.viewQuoteFireSA?.conditions?.default
                    : [],
                userDefinedConditions:
                  data?.viewQuoteFireSA?.conditions?.userDefined &&
                  data?.viewQuoteFireSA?.conditions?.userDefined
                    ?.length > 0
                    ? data?.viewQuoteFireSA?.conditions?.userDefined
                    : [],
                Description:
                data?.viewQuoteFireSA?.conditions?.Description &&
                data?.viewQuoteFireSA?.conditions?.Description?.length >
                  0
                  ? data?.viewQuoteFireSA?.conditions?.Description
                  : [],
                ConditionCode:
                data?.viewQuoteFireSA?.conditions?.ConditionCode &&
                data?.viewQuoteFireSA?.conditions?.ConditionCode?.length >
                  0
                  ? data?.viewQuoteFireSA?.conditions?.ConditionCode
                  : [],
                ConditionNumber:
                data?.viewQuoteFireSA?.conditions?.ConditionNumber &&
                data?.viewQuoteFireSA?.conditions?.ConditionNumber?.length >
                  0
                  ? data?.viewQuoteFireSA?.conditions?.ConditionNumber
                    : [],
              },
              warranties: {
                defaultWarranties:
                  data?.viewQuoteFireSA?.warranties?.default &&
                  data?.viewQuoteFireSA?.warranties?.default?.length > 0
                    ? data?.viewQuoteFireSA?.warranties?.default
                    : [],
                userDefinedWarranties:
                  data?.viewQuoteFireSA?.warranties?.userDefined &&
                  data?.viewQuoteFireSA?.warranties?.userDefined
                    ?.length > 0
                    ? data?.viewQuoteFireSA?.warranties?.userDefined
                    : [],
                Description:
                data?.viewQuoteFireSA?.warranties?.Description &&
                data?.viewQuoteFireSA?.warranties?.Description?.length >
                  0
                  ? data?.viewQuoteFireSA?.warranties?.Description
                  : [],
                WarrantyCode:
                data?.viewQuoteFireSA?.warranties?.WarrantyCode &&
                data?.viewQuoteFireSA?.warranties?.WarrantyCode?.length >
                  0
                  ? data?.viewQuoteFireSA?.warranties?.WarrantyCode
                  : [],
                WarrantyNumber:
                data?.viewQuoteFireSA?.warranties?.WarrantyNumber &&
                data?.viewQuoteFireSA?.warranties?.WarrantyNumber?.length >
                  0
                  ? data?.viewQuoteFireSA?.warranties?.WarrantyNumber
                  : [],
              },
              exclusions: {
                defaultExclusions:
                  data?.viewQuoteFireSA?.exclusions?.default &&
                  data?.viewQuoteFireSA?.exclusions?.default?.length > 0
                    ? data?.viewQuoteFireSA?.exclusions?.default
                    : [],
                userDefinedExclusions:
                  data?.viewQuoteFireSA?.exclusions?.userDefined &&
                  data?.viewQuoteFireSA?.exclusions?.userDefined
                    ?.length > 0
                    ? data?.viewQuoteFireSA?.exclusions?.userDefined
                    : [],
                Description:
                data?.viewQuoteFireSA?.exclusions?.Description &&
                data?.viewQuoteFireSA?.exclusions?.Description?.length >
                  0
                  ? data?.viewQuoteFireSA?.exclusions?.Description
                  : [],
                ExclusionCode:
                data?.viewQuoteFireSA?.exclusions?.ExclusionCode &&
                data?.viewQuoteFireSA?.exclusions?.ExclusionCode?.length >
                  0
                  ? data?.viewQuoteFireSA?.exclusions?.ExclusionCode
                  : [],
                ExclusionNumber:
                data?.viewQuoteFireSA?.exclusions?.ExclusionNumber &&
                data?.viewQuoteFireSA?.exclusions?.ExclusionNumber?.length >
                  0
                  ? data?.viewQuoteFireSA?.exclusions?.ExclusionNumber
                    : [],
              },
              underwriterComment: data?.viewQuoteFireSA
                ?.underwriterComment
                ? data?.viewQuoteFireSA?.underwriterComment
                : '',
            },
          },
        });
        updateFireQuoteUploadDocsVar({
          documentDetails:
            data?.viewQuoteFireSA?.uploadedDocuments &&
            data?.viewQuoteFireSA?.uploadedDocuments?.length > 0
              ? data?.viewQuoteFireSA?.uploadedDocuments?.map(
                  (uploadDet) => {
                    return {
                      documentDescription: '',
                      documentName: uploadDet?.documentType?.code
                        ? `${uploadDet?.documentType?.code}`
                        : '',
                      documentNameValue: uploadDet?.documentType
                        ?.value
                        ? `${uploadDet?.documentType?.value}`
                        : '',
                      documentFileName: uploadDet?.documentName
                        ? `${uploadDet?.documentName?.split('.')[0]}`
                        : '',
                      documentFileNameWithExtension:
                        uploadDet?.documentName
                          ? `${uploadDet?.documentName}`
                          : '',
                      documentExtension:
                        dataDocumentExtensions?.documentExtensions?.find(
                          (extension) =>
                            extension?.value
                              ?.toString()
                              ?.toLowerCase() ===
                            uploadDet?.documentName
                              ?.split('.')
                              .pop()
                              ?.toString()
                              ?.toLowerCase(),
                        )?.code,
                      documentSize: parseFloat(
                        parseFloat(uploadDet?.documentSize)?.toFixed(
                          2,
                        ),
                      ),
                      documentSizeinKB: uploadDet?.documentSize
                        ? `${uploadDet?.documentSize}`
                        : '',
                      documentBase64String:
                        uploadDet?.base64EncodedDoc
                          ? `${uploadDet?.base64EncodedDoc}`
                          : '',
                    };
                  },
                )
              : [],
        });
      } catch (error) {}
    },
  });

  return loading ||
    loadingMyIntermediaries ||
    loadingRole ||
    loadingDocumentExtensions ? (
    <Loading />
  ) : error ||
    errorMyIntermediaries ||
    errorRole ||
    errorDocumentExtensions ? (
    <Error
      error={{
        message: `There was an issue fetching the Quote Details`,
      }}
    />
  ) : data &&
    (dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuoteFireSA?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ||
    (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() !==
      'underwriter' ||
      (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
        'underwriter' &&
        [
          'pending uw approval',
          'underwriter approved',
          'underwriter rejected',
        ]?.includes(
          data?.viewQuoteFireSA?.status?.toString()?.toLowerCase(),
          )))) ? (
    <CaptureFireDetailsSF
      productName={data?.viewQuoteFireSA?.product?.productName?.toString() === 'Kotak Bharat Griha Raksha'
        ? 'Bharat Griha Raksha'
        : 'Griha Raksha Plus'
      }
      productCode={data?.viewQuoteFireSA?.product?.productCode}
      lobCode={data?.viewQuoteFireSA?.lob?.lobCode}
      currentTab={
        data?.viewQuoteFireSA?.status?.toString()?.toLowerCase() ===
          'pending uw approval' &&
        dataRole.checkAuth.role.roleName
          ?.toString()
          ?.toLowerCase() === 'underwriter'
          ? 3
          : data?.viewQuoteFireSA?.stageIndex
      }
      quoteNumber={quote_number}
      status={data?.viewQuoteFireSA?.status}
      breadcrumbNav={['Quote', 'View Quote']}
      expandedCards={data?.viewQuoteFireSA?.riskLocations}
      userRole={dataRole?.checkAuth?.role?.roleName}
    />
  ) : data &&
    !dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuoteFireSA?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuoteFireSA?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view quote belonging to
          another intermediary.
        </Text>
      </Card>
    </Layout>
  ) : dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
      'underwriter' &&
    ![
      'pending uw approval',
      'underwriter approved',
      'underwriter rejected',
    ]?.includes(
      data?.viewQuoteFireSA?.status?.toString()?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuoteFireSA?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Quote is invalid or not belonging to UW approved, UW
          rejected or pending for UW approval
        </Text>
      </Card>
    </Layout>
  ) : null;
}
